import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BasicLayout from '@/layouts/BasicLayout';
/**
 * 虚拟展厅
 */

var virtual = {
  path: '/virtual',
  component: BasicLayout,
  redirect: '/virtual',
  children: [{
    path: '/virtual',
    name: 'Virtual',
    component: function component() {
      return import('views/virtual/VirtualDownload');
    },
    meta: {
      title: '虚拟展厅'
    }
  }]
};
export default virtual;